import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogContent,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { COPY_CANDIDATE } from "../../Schema/Candidate";
import { DialogTitleComp } from "../../Utils/Component";
import { SelectMandateForCopyCadidate, SelectPartyForCopyCandidate } from "../Include/DynamicSelect";

export default function CopyCandidateForm({
  open,
  setRefetch,
  handleClose,
}) {

  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [copyCandidate] = useMutation(COPY_CANDIDATE, {
    onCompleted: ({ copyCandidate }) => {
      setLoading(false);
      if (copyCandidate?.isSuccess === true) {
        setAlert(true, "success", copyCandidate?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", copyCandidate?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });



  //fromik
  const CheckValidation = Yup.object().shape({
    partyId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    mandateId: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      mandateId: { id: "", title: "" },
      partyId: { id: "", title: "" },
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      copyCandidate({
        variables: {
          mandateId: values?.mandateId?.id,
          partyId: values?.partyId?.id,
        },
      });
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = formik;

  useEffect(() => {
    if (open) resetForm();
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs" fullWidth>
      <DialogTitleComp
        title={t("modal_title_copy_candidate")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_mandate")}
                </Typography>
                <SelectMandateForCopyCadidate
                  value={values?.mandateId}
                  onChange={(val) => setFieldValue("mandateId", val)}
                  error={Boolean(touched.mandateId?.id && errors.mandateId?.id)}
                  helperText={touched.mandateId?.id && errors.mandateId?.id}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_party")}
                </Typography>
                <SelectPartyForCopyCandidate
                  mandateId={values?.mandateId?.id}
                  error={Boolean(touched.partyId?.id && errors.partyId?.id)}
                  helperText={touched.partyId?.id && errors.partyId?.id}
                  value={values?.partyId}
                  onChange={(val) => setFieldValue("partyId", val)}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("copy")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
